import { Navigate, Route, Routes } from 'react-router-dom';

import { AppSettingsScreen } from '../features/app-settings/AppSettingsScreen';
import { AssetsScreen } from '../features/assets/AssetsScreen';
import { useAuthStore } from '../features/auth/authStore';
import { LoginScreen } from '../features/auth/LoginScreen';
import { AppListScreen } from '../features/layout-builder/components/AppListScreen';
import { BuilderScreen } from '../features/layout-builder/components/BuilderScreen';

export function App() {
  const accessToken = useAuthStore((s) => s.accessToken);

  return (
    <Routes>
      <Route
        path="/login"
        element={accessToken ? <Navigate to="/" replace /> : <LoginScreen />}
      />
      <Route
        path="/"
        element={accessToken ? <AppListScreen /> : <Navigate to="/login" replace />}
      />
      {/*
       * App-scoped routes:
       *   /apps/:appId           → App Settings (landing for an app)
       *   /apps/:appId/builder   → View Builder (drag-drop tree)
       *
       * Settings is the default so authors land on app-level config (icon,
       * splash, bundle ids, etc.) and explicitly enter the View Builder
       * when they're ready to edit screens.
       */}
      <Route
        path="/apps/:appId"
        element={accessToken ? <AppSettingsScreen /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/apps/:appId/builder"
        element={accessToken ? <BuilderScreen /> : <Navigate to="/login" replace />}
      />
      {/*
       * Assets is org-scoped — all apps in the org share the same library
       * — so it lives at the top level rather than under /apps/:appId.
       */}
      <Route
        path="/assets"
        element={accessToken ? <AssetsScreen /> : <Navigate to="/login" replace />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
